import { Patientallergy } from "../../../../../../../services";
import { createMapper } from "../../../../../../../utils/utils";
import * as Yup from "yup";

export const SEVERITY_LIST = [
  { value: "MILD", label: "Mild" },
  { value: "MODERATE", label: "Moderate" },
  { value: "SEVERE", label: "Severe" },
];

export type SeverityValue = (typeof SEVERITY_LIST)[number]["value"];


export const SEVERITY_RECORD = createMapper(SEVERITY_LIST);


export const PatientSEVERITY_COLOR: Record<SeverityValue, string> = {
  MILD: "#049B22",
  MODERATE: "#943C00",
  SEVERE: "#B1000F",
};

export const PatientSEVERITY_BG_COLOR: Record<string, string> = {
            MILD: "#E1FCDE",
            MODERATE: "#FFF2D2",
            SEVERE: "#FFF2F3",
          };
export const PatientSEVERITY_RECORD = createMapper(SEVERITY_LIST);

export const STATUS_LIST: { value: boolean | string; label: string }[] = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const ALLERGY_INITIAL_VALUES: Omit<Patientallergy, "patient"> = {
  allergyType: undefined,
  allergy: "",
  active: true,
};

export const ALLERGY_VALIDATION = Yup.object().shape({
  allergy: Yup.string()
    .trim()
    .required()
    .matches(/[a-zA-Z]/, "Allergy Name must contain at least one letter")
    .label("Allergy Name"),
  active: Yup.boolean().required().label("Status"),
});
